import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from 'contentful';

import type { TypeFaqSkeleton } from './TypeFaq';

export interface TypeBlockFaqFields {
    internalName: EntryFieldTypes.Symbol;
    visibility?: EntryFieldTypes.Symbol<'loggedIn' | 'loggedOut'>;
    title?: EntryFieldTypes.Symbol;
    colorOption?: EntryFieldTypes.Symbol<'color-dark-purple' | 'color-light-grey'>;
    faqItems?: EntryFieldTypes.Array<EntryFieldTypes.EntryLink<TypeFaqSkeleton>>;
}

export type TypeBlockFaqSkeleton = EntrySkeletonType<TypeBlockFaqFields, 'blockFaq'>;
export type TypeBlockFaq<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<
    TypeBlockFaqSkeleton,
    Modifiers,
    Locales
>;

export function isTypeBlockFaq<Modifiers extends ChainModifiers, Locales extends LocaleCode>(
    entry: unknown,
): entry is TypeBlockFaq<Modifiers, Locales> {
    const candidate = entry as { sys?: { contentType?: { sys?: { id?: string } } } };

    return candidate.sys?.contentType?.sys?.id === 'blockFaq';
}
